import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { themes, defaultTheme, type Theme } from '../constants/themes';

interface AppState {
  theme: string;
  setTheme: (theme: string) => void;
  getCurrentTheme: () => Theme;
}

export const useStore = create<AppState>()(
  persist(
    (set, get) => ({
      theme: defaultTheme,
      setTheme: (theme: string) => set({ theme }),
      getCurrentTheme: () => themes[get().theme] || themes[defaultTheme],
    }),
    {
      name: 'gm-dashboard-storage',
    }
  )
);
